// Author Lin
// Date 2021-11-03 10:35:47

class MintalMesPrdSmeltingResistanceBeforeIron {
    constructor({
            id = null,
            slagIronId = '',
            firstElectrodeResistance = '',
            secondElectrodeResistance = '',
            thirdElectrodeResistance = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.slagIronId = slagIronId;
        this.firstElectrodeResistance = firstElectrodeResistance;
        this.secondElectrodeResistance = secondElectrodeResistance;
        this.thirdElectrodeResistance = thirdElectrodeResistance;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesPrdSmeltingResistanceBeforeIron();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'slagIronId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.slagIronId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'startTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.startTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'dischargeTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.dischargeTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'firstElectrodeResistance',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.firstElectrodeResistance',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'secondElectrodeResistance',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.secondElectrodeResistance',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'thirdElectrodeResistance',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.thirdElectrodeResistance',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        slagIronIdFilter : '',
        firstElectrodeResistanceFilter : '',
        secondElectrodeResistanceFilter : '',
        thirdElectrodeResistanceFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'slagIronIdFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.filter.slagIronId',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesPrdSmeltingSlagIron'
                ,correspondingField: 'id'
                    }
            },
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'slagIronId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.entity.slagIronId',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesPrdSmeltingSlagIron'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'firstElectrodeResistance',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.entity.firstElectrodeResistance',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'secondElectrodeResistance',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.entity.secondElectrodeResistance',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'thirdElectrodeResistance',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.entity.thirdElectrodeResistance',
            sortable: true,
            disabled: false,
            form: {
            type: 'inputNumber'
                    }
            },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdSmeltingResistanceBeforeIron.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesPrdSmeltingResistanceBeforeIron, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    